/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GraphDefs from './defs.defs.js'
import * as RichtextFacet from '../richtext/facet.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'

const $nsid = 'app.bsky.graph.list'

export { $nsid }

/** Record representing a list of accounts (actors). Scope includes both moderation-oriented lists and curration-oriented lists. */
type Main = {
  $type: 'app.bsky.graph.list'

  /**
   * Defines the purpose of the list (aka, moderation-oriented or curration-oriented)
   */
  purpose: GraphDefs.ListPurpose

  /**
   * Display name for list; can not be empty.
   */
  name: string
  description?: string
  descriptionFacets?: RichtextFacet.Main[]
  avatar?: l.BlobRef
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject
  createdAt: l.DatetimeString
}

export type { Main }

/** Record representing a list of accounts (actors). Scope includes both moderation-oriented lists and curration-oriented lists. */
const main = l.record<'tid', Main>(
  'tid',
  $nsid,
  l.object({
    purpose: l.ref<GraphDefs.ListPurpose>((() => GraphDefs.listPurpose) as any),
    name: l.string({ maxLength: 64, minLength: 1 }),
    description: l.optional(l.string({ maxGraphemes: 300, maxLength: 3000 })),
    descriptionFacets: l.optional(
      l.array(l.ref<RichtextFacet.Main>((() => RichtextFacet.main) as any)),
    ),
    avatar: l.optional(
      l.blob({ accept: ['image/png', 'image/jpeg'], maxSize: 1000000 }),
    ),
    labels: l.optional(
      l.typedUnion(
        [l.typedRef<LabelDefs.SelfLabels>((() => LabelDefs.selfLabels) as any)],
        false,
      ),
    ),
    createdAt: l.string({ format: 'datetime' }),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
